import React from 'react';
import styled, {ThemeProvider} from 'styled-components';
import {DefaultTheme, DarkTheme } from 'trustar-2.0/themes';

type DesignSystemProviderPropType = {
  children: any,
  theme: 'default' | 'dark',
};

const initialValues = {
  theme: 'default'
};

export const DesignSystemProvider = (props: DesignSystemProviderPropType) => {
  const className = props.theme === 'default' ? 'trustar' : 'trustar-dark';
  const themeConfiguration = props.theme === 'default' ? DefaultTheme : DarkTheme;
  return (
    <div className={className}>
      <ThemeProvider theme={themeConfiguration}>
        {props.children}
      </ThemeProvider>
    </div>);
};

DesignSystemProvider.defaultProps = initialValues;

export default DesignSystemProvider;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/DesignSystemProvider.js